import React from 'react';
import PropTypes from 'prop-types';
import EventVisitDetailsComponent from './event-visit';
import EventFairDetailsComponent from './event-fair';
import Container from '../../components/Container';
import Header from '../../components/Header';
import './styles.css';

const RepVisitsCalendarEventDetailsSideBar = ({
  event,
  onSave,
  dismissNotification,
  onlyVisitUrl,
  notificationId,
}) => {
  if (event == null) {
    return (
      <Container styleName="event-details">
        <Header as="h1">
          There is a problem with this event.
        </Header>
      </Container>
    );
  }

  if (event.dayId) {
    return (
      <EventVisitDetailsComponent
        appointmentId={event.appointmentId}
        id={event.dayId}
        onSave={onSave}
        dismissNotification={dismissNotification}
        onlyVisitUrl={onlyVisitUrl}
        notificationId={notificationId}
      />
    );
  } else {
    return (
      <EventFairDetailsComponent
        id={event.collegeFairId}
        onSave={onSave}
      />
    );
  }
};

RepVisitsCalendarEventDetailsSideBar.propTypes = {
  event: PropTypes.object.isRequired,
  onSave: PropTypes.func,
  onlyVisitUrl: PropTypes.bool,
  notificationId: PropTypes.string,
};

export default RepVisitsCalendarEventDetailsSideBar;
